/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LineAllocationDto } from './LineAllocationDto';
import {
    LineAllocationDtoFromJSON,
    LineAllocationDtoFromJSONTyped,
    LineAllocationDtoToJSON,
} from './LineAllocationDto';

/**
 * 
 * @export
 * @interface AllocateLineDto
 */
export interface AllocateLineDto {
    /**
     * 
     * @type {Array<LineAllocationDto>}
     * @memberof AllocateLineDto
     */
    allocations: Array<LineAllocationDto>;
}

/**
 * Check if a given object implements the AllocateLineDto interface.
 */
export function instanceOfAllocateLineDto(value: object): value is AllocateLineDto {
    if (!('allocations' in value) || value['allocations'] === undefined) return false;
    return true;
}

export function AllocateLineDtoFromJSON(json: any): AllocateLineDto {
    return AllocateLineDtoFromJSONTyped(json, false);
}

export function AllocateLineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllocateLineDto {
    if (json == null) {
        return json;
    }
    return {
        
        'allocations': ((json['allocations'] as Array<any>).map(LineAllocationDtoFromJSON)),
    };
}

export function AllocateLineDtoToJSON(value?: AllocateLineDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'allocations': ((value['allocations'] as Array<any>).map(LineAllocationDtoToJSON)),
    };
}

